export const DEFAULT_DATE_FORMATE = 'MM-dd-yyyy';
export const DEFAULT_API_URL = 'https://ibh.medgre.com/medgre';
export const DEFAULT_LOCAL_PATH = '/mod';
export const COMMUNICATION_TAB = true;
export const CLINIC_NAME = 'Inspire Behavioral Health';
export const START_OF_WEEK = { weekStartsOn: 1 }; //=> 1=>Week start on Monday 0=>week starts on Sunday
export const VERSION = '1.3.38619.1';
